<template>
  <div
    v-if="list.length"
    class="l-flex-grid"
    >
      <el-tag
        class="u-ml0 u-mr2 u-mb1"
        v-for="(item, index) in list"
        :key="index"
      >
        {{item.name}}
      </el-tag>
  </div>
</template>

<script>
export default {
  name: 'NoteTagsList',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>
